// Sticky Header
export function stickyHeader() {
  /* FIXED HEADER - adjust header on scroll */

  const stickyTrigger = document.getElementById('header-alert').offsetHeight;
  window.addEventListener('scroll', () => {
    if (window.scrollY >= stickyTrigger) {
      document.body.classList.add('sticky');
    } else {
      document.body.classList.remove('sticky');
    }
  });

  /* FIXED MAIN NAV ONLY */

  /* const stickyTrigger = document.getElementById('masthead').offsetHeight;
  const stickyElement = document.getElementById('site-header-main');
  const navElement = document.getElementById('primary-nav-menu');
  const mtElement = document.querySelector('.content-wrapper');

  window.addEventListener('scroll', () => {
    if (window.scrollY >= stickyTrigger) {
      const elHeight = (stickyElement).offsetHeight;
      document.body.classList.add('sticky');
      if (mtElement) mtElement.style.marginTop = elHeight + 'px';
      //if (navElement) navElement.style.setProperty('--header-height', elHeight + 'px');
    } else {
      document.body.classList.remove('sticky');
      if (mtElement) mtElement.style.marginTop = 0;
      //if (navElement) navElement.style.setProperty('--header-height', '');
    }
  }); */

  /* SLIDE DOWN ON SCROLL */
  /* const stickyTrigger = document.getElementById('masthead').offsetHeight;
  const scrollTriggerOffset = 78.48px;
  const mtElement = document.querySelector('.content-wrapper');
  const masthead = document.getElementById('masthead');
  // if (masthead) {
  //   masthead.style.insetBlockStart = '-' + stickyTrigger + 'px';
  // }

  window.addEventListener('scroll', () => {
    if (window.scrollY > (stickyTrigger + scrollTriggerOffset)) {
      document.body.classList.add('sticky');
      if (masthead) {
        masthead.style.insetBlockStart = 0 + 'px';
      }
      if (mtElement) mtElement.style.marginBlockStart = stickyTrigger + 'px';
    } else if (window.scrollY <= stickyTrigger) {
      document.body.classList.remove('sticky');
      if (masthead) {
        masthead.style.insetBlockStart = stickyTrigger + 'px';
      }
      if (mtElement) mtElement.style.marginBlockStart = '';
    }
  }); */

  /* ANIMATED ON SCROLL UP */
  /* const stickyTrigger = document.getElementById('masthead').offsetHeight;
  let lastScrollPosition = 0;

  window.addEventListener('scroll', () => {
    let currentScrollPosition = window.scrollY;

    if (currentScrollPosition < lastScrollPosition) {
      document.body.classList.remove('hide-sticky');
      document.body.classList.add('sticky');
      if (currentScrollPosition === 0) {
        document.body.classList.remove('sticky');
      }
    } else {
      document.body.classList.remove('sticky');
      document.body.classList.add('hide-sticky');
    }

    lastScrollPosition = currentScrollPosition;
  }); */
}
